import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store' // eslint-disable-line
import Home from '@/views/Home.vue'
import base from '@/mixins/base' // eslint-disable-line
import { Base64 } from 'js-base64'; // Base64 package import

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/404')
  },
  {
    path: '/online-sinav',
    name: 'HomeWork',
    component: () => import('@/views/HomeWork')
  },
  {
    path: '/online-sinav/gecmis',
    name: 'OldHomeWork',
    component: () => import('@/views/OldHomeWork')
  },
  {
    path: '/online-sinav/:id',
    name: 'HomeWorkDetail',
    component: () => import('@/views/HomeWorkDetail')
  },
  {
    path: '/online-sinav/:id/yazdir',
    name: 'HomeWorkPrint',
    component: () => import('@/views/HomeWorkPrint')
  },
  {
    path: '/giris-yap',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.scroll) {
      const element = document.querySelector('.router-link-exact-active');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return {};
      }
    }
    return savedPosition || { x: 0, y: 0 };
  },
})

router.beforeEach(async (to, from, next) => { 
  NProgress.start()
  let authControl = null; // eslint-disable-line
  if (to.query.token !== undefined) {
    try {
      let token = Base64.decode(to.query.token + '==')
      token = JSON.parse(token)
      await base.methods.authData(token.kullaniciAdi, token.sifre);
      if (store.state.auth.isLogged) {
        authControl = true
      } else {
        authControl = false
      }
    } catch (e) {
      next({ name: to.name, params: to.params })
    }
  }
  // A U T H   C O N T R O L
  if (store.state.auth.isLogged) { // IS LOGGED
    authControl = true
  } else if (localStorage.getItem('auth')) { // AUTH STORAGE CONTROL
    let auth = Base64.decode(localStorage.getItem('auth'));
    auth = JSON.parse(auth)
    await base.methods.authData(auth.tc, auth.pass);
    if (store.state.auth.isLogged) {
      authControl = true
    } else {
      authControl = false
    }
    /*
    let authInterval = setInterval(() => {
      if (typeof store.state.auth.isLogged === 'boolean') {
        
        clearInterval(authInterval);
      }
    }, 25);
    */

  } else { // IS NOT LOGGED
    authControl = false
  }

  if (!authControl && to.name != 'Login') {
    next({ name: 'Login' })
  } else if (authControl && to.name == 'Login') {
    next({ name: 'Home' })
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.set(0.8)
  setTimeout(() => {
    NProgress.done()
  }, 200)
})

export default router